module.exports = __webpack_public_path__ + "static/media/sweet-barrel.b2493501.jpg";